import { render, staticRenderFns } from "./VSelectPaymentMethod.vue?vue&type=template&id=1c767370&scoped=true&"
import script from "./VSelectPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./VSelectPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c767370",
  null
  
)

export default component.exports